import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MenuService } from 'ahm-angular';
import { Subscription } from 'rxjs';
import { MENU } from 'src/config/menu';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  title = MENU.title;
  env: string = "local";

  constructor(private _menu: MenuService, private _titleService: Title) {
    this.env = environment.environment;
    this._titleService.setTitle(MENU.title);
    _menu.setMenu(MENU);
  }


}
